import { useEffect } from 'react';
import { useAuth } from './useAuth';
import { createSurveyRequest } from '../services/surveys';

export interface ISurveyData {
  survey: string;
  lang: string;
  name: string;
  organization?: string;
  organizationId?: string | undefined;
  copyFrom?: number;
}

export const useSurveyModal = () => {
  const { userRolesFromToken } = useAuth();

  const createSurvey = async (surveyData: ISurveyData) => {
    const { organization, survey, name, copyFrom } = surveyData;
    const basicPayloadObject: { type: string; name: string; copyFrom?: number } = {
      type: survey,
      name,
    };

    if (copyFrom) {
      basicPayloadObject.copyFrom = copyFrom;
    }

    if (!organization) {
      const { organizationId } = userRolesFromToken;
      const payload = { ...basicPayloadObject, organizationId: String(organizationId) };
      return await createSurveyRequest(payload);
    } else {
      const payload = { ...basicPayloadObject, organizationId: String(surveyData.organizationId) };
      return await createSurveyRequest(payload);
    }
  };

  useEffect(() => {
    const modalIdName = 'createSurvey';
    const modalId = document.createElement('div');
    modalId.setAttribute('id', modalIdName);
    document.body.appendChild(modalId);
    return () => {
      const modal = document.getElementById(modalIdName);
      modal?.remove();
    };
  }, []);

  return { createSurvey };
};
